// These are currently coming from the node_modules folder.
import "babel-polyfill";
import "angular";
import "angular-route";
import "angular-animate";
import "angular-ui-bootstrap";
import "moment";
window.moment = require("moment"); //moment library doesn't set this automatically - must do it manually
import "angular-sanitize";
import "angular-cookies";
import "angular-ui-sortable";
import "angular-ui-switch";

// translation dependencies
import "angular-translate";
import "angular-translate-loader-static-files";
import "angular-translate-storage-cookie";
import "angular-translate-storage-local";
import "angular-translate-handler-log";

// TODO: use npm for bootstrap and select.min.css and angular-ui-switch.  than reference css files here from node_modules
require("./css/bootstrap.min.css");
require("./css/bootstrap-datetimepicker.min.css");
require("./node_modules/angular-ui-switch/angular-ui-switch.min.css");

// TODO: make all vendor files from npm and the node_modules folder.
import "./js/vendor/jquery-ui-1.10.4.custom.min.js";
import "./js/vendor/showErrors.js";
import "./js/vendor/ui-utils.min.js";
import "./js/vendor/bootstrap.min.js";
import "./js/vendor/bootstrap-datetimepicker.min.js";
import "./js/vendor/base64.min.js";
import "./js/vendor/angular-dynamic-locale/dist/tmhDynamicLocale.js";
import "./js/vendor/angular-visibility-change.min.js";



// WEBPACK FOOTER //
// ./vendor.js